import client from "~/apis/client"

export function requestReset(emailAddress) {
  return client.post("/passwords", { email_address: emailAddress })
}

export function resetPassword(token, password, passwordConfirmation) {
  return client.patch(`/passwords/${token}`, { password, password_confirmation: passwordConfirmation })
}
